import PageLoader from '../../UI/loader/PageLoader';
import ProtectionPoliciesContentNew from './protection-policies/ProtectionPoliciesContentNew';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import NetWorthAccordion from './net-worth/NetWorthAccordion';
import useFinancialItems from 'src/financial/financial-data/hooks/useFinancialItems';
import { useNavigate, useParams } from 'react-router';
import { CreateFinancialItemPicker } from 'src/financial/financial-data/financial-item/CreateFinancialItemDrawer';
import { FinancialContentRework } from 'src/financial/financial-data/rework/FinancialContentRework';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { useEffect } from 'react';
import { useAppContainerContext } from 'src/UI/app-container/AppContainerContext';

export const FinancialContent = () => {
  const { clientId, client } = useCurrentClient();
  const { sectionSlug } = useParams();
  const navigate = useNavigate();
  const { setSidebarCollapsed } = useAppContainerContext();
  const { flagEnabledFinancialRework } = useFlags();

  const isCreateView = sectionSlug === 'create';

  useEffect(() => {
    if (isCreateView) {
      setSidebarCollapsed(true);
      return () => setSidebarCollapsed(false);
    }
  }, [isCreateView, setSidebarCollapsed]);

  const {
    isLoading: loadingFinancialItems,
    refetch: refetchFinancialItems,
    isFetching,
    ...financialItems
  } = useFinancialItems(clientId);

  const refetch = async () => {
    await Promise.all([refetchFinancialItems()]);
  };

  if (loadingFinancialItems || !client) {
    return <PageLoader absolute={false} />;
  }

  if (sectionSlug === 'create') {
    return (
      <CreateFinancialItemPicker onClose={() => navigate(`/client/${clientId}/financial-data`)} />
    );
  }

  if (flagEnabledFinancialRework && clientId) {
    return (
      <FinancialContentRework
        clientId={clientId}
        clientFirstName={client.firstName}
        financialItems={financialItems}
      />
    );
  }

  return (
    <>
      <NetWorthAccordion
        onSubmit={refetch}
        financialItems={financialItems}
        isFetching={isFetching}
      />
      <ProtectionPoliciesContentNew
        policies={financialItems.protections}
        clientFirstName={client.firstName}
      />
    </>
  );
};
